export default {
  // 使用的global變數一律定義在這裡,每個變數上面要附加註解說明用途
  'session': null,
  'landingComponent': 'Info',
  // 由某些操作連結要開啟其他功能時,原則上只要修改this.$bus.landingComponent即可
  // 但如果希望跳過去時可以帶參數決定那個view初始狀態,且還想要可以快速回去前一個動作的位置,需要特定機制與數據傳遞
  // 因為沒弄global的store,所以在這裡安排一個stack的陣列
  // 碰到有需要跳過去就新增兩個元素,先push自己的組件以備回來,再push一個目標組件與傳遞的子屬性參數物件
  // 每個索引頭的組件(被掛在landing page)都要在mounted裡
  'linkCallStack':[],
  //這是要被hook進來的function,外面傳進來,呼叫api發生登入憑證無效時,alert後call這個跳回登入
  'fnGoLogin': null,
  'fnShowInfo': null,
  'fnShowConfirm': null,
  'fnClosePopup':null,
  // filter form預設的input type,配置控制項時碰到類型符合以下者用b-form-input render
  'formInputTypes':[
    'text', 'password', 'email', 'number', 'url',
    'tel', 'date', `time`, 'range', 'color'
  ],
  // 提供額外機制來暫時隱藏手機版型的導覽列,如聊天功能視窗下面會壓到輸入送出的部分,當聊天組件被打開時就透過設定此屬性暫時隱藏,關閉時再重新恢復顯示
  hideMobileNavi:false,
  roleFunctionsMap: {
    /*'admin': [
      {"index":0,"FunTitle":"統計報表","actionComponent":"Statistics","imgUrl":require('../assets/images/money_on@2x.png')},
      {"index":1,"FunTitle":"課程管理","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      {"index":2,"FunTitle":"銷售管理組合","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":3,"FunTitle":"劃位設定","actionComponent":"","imgUrl":require('../assets/images/appointment_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"店家劃位設定","actionComponent":"StoreManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"店家公休日處理","actionComponent":"UnderConstrunction","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":4,"FunTitle":"供應商管理","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":5,"FunTitle":"內部使用","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
        {"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":6,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":7,"FunTitle":"票券處理","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":8,"FunTitle":"用戶評價查詢","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},
    ],
    'admin_sales': [
      {"index":0,"FunTitle":"統計報表","actionComponent":"Statistics","imgUrl":require('../assets/images/money_on@2x.png')},
      {"index":1,"FunTitle":"課程管理","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      {"index":2,"FunTitle":"銷售管理組合","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      //{"index":3,"FunTitle":"做預約","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":3,"FunTitle":"店家管理","actionComponent":"","imgUrl":require('../assets/images/appointment_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"店家劃位設定","actionComponent":"StoreManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"店家公休日處理","actionComponent":"UnderConstrunction","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":4,"FunTitle":"供應商管理","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":5,"FunTitle":"內部使用","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
        {"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"預約管理","actionComponent":"ReservationAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":6,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":7,"FunTitle":"用戶評價查詢","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},
    ],
    'admin_support': [
      {"index":0,"FunTitle":"做預約","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":1,"FunTitle":"課程管理","actionComponent":"Tickets","imgUrl":require('../assets/images/ticket_on@2x.png')},
      {"index":2,"FunTitle":"供應商管理","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":3,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷紀錄查詢","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷日曆查看","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":3,"FunTitle":"請款單查看","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]},
      {"index":4,"FunTitle":"票券處理","actionComponent":"TicketProcess","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":5,"FunTitle":"用戶評價查詢","actionComponent":"UserScoreManage","imgUrl":require('../assets/images/management_on@2x.png')},
    ],
    'merchant_admin': [
      {"index":0,"FunTitle":"重要訊息","actionComponent":"Info","imgUrl":require('../assets/images/notification_on@2x.png')},
      //{"index":1,"FunTitle":"建立可候補排程","actionComponent":"TemplateSchedule","imgUrl":require('../assets/images/calendar_on@2x.png')},
      //{"index":2,"FunTitle":"候補管理","actionComponent":"WaitlistAdmin","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":1,"FunTitle":"銷售管理組合","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":2,"FunTitle":"核銷日曆查看","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":3,"FunTitle":"分店管理","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
      {"index":4,"FunTitle":"請款作業","actionComponent":"PaymentFormAdminView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":5,"FunTitle":"核銷紀錄查詢","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
    ],
    'merchant_store': [
      {"index":0,"FunTitle":"重要訊息","actionComponent":"Info","imgUrl":require('../assets/images/notification_on@2x.png')},
      {"index":1,"FunTitle":"銷售管理組合","actionComponent":"SalesViewCombo","imgUrl":require('../assets/images/appointment_on@2x.png')},
      {"index":2,"FunTitle":"請款/核銷","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
          {"index":1,"FunTitle":"核銷日曆查看","actionComponent":"ServiceExecutionView","imgUrl":require('../assets/images/appointment_on@2x.png')},
          {"index":2,"FunTitle":"核銷紀錄查詢","actionComponent":"ServiceExecutionList","imgUrl":require('../assets/images/appointment_on@2x.png')},
        ]
      },
      {"index":3,"FunTitle":"劃位設定","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"休息時段","actionComponent":"StoreRestTimeManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"自動接受劃位","actionComponent":"StoreAutoAcceptManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"公休日","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":4,"FunTitle":"自訂外部劃位","actionComponent":"StoreExtRvTypeManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":4,"FunTitle":"預約管理","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"每日預約檢視","actionComponent":"StoreRcManage","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"預約管理","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"劃位邀請與確認","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":4,"FunTitle":"顧客好友維護","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        //{"index":5,"FunTitle":"組件測試","actionComponent":"StoreRcView","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":5,"FunTitle":"課程檢視/操作","actionComponent":"","imgUrl":require('../assets/images/management_on@2x.png'),subActions:[
        {"index":1,"FunTitle":"配合課程管理","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":2,"FunTitle":"課程票券","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
        {"index":3,"FunTitle":"課程劃位","actionComponent":"UnderConstruction","imgUrl":require('../assets/images/appointment_on@2x.png')},
      ]},
      {"index":6,"FunTitle":"子帳號管理","actionComponent":"MerchantManage","imgUrl":require('../assets/images/management_on@2x.png')},
    ],
    'user': [
      {"index":0,"FunTitle":"重要訊息","actionComponent":"Info","imgUrl":require('../assets/images/notification_on@2x.png')},
      {"index":1,"FunTitle":"做預約","actionComponent":"MakeReservation","imgUrl":require('../assets/images/appointment_on@2x.png')},
    ]*/
    'merchant_admin': [
      {
        "index":0,
        "FunTitle":"票券核銷請款查詢",
        "actionComponent":"ServiceExecutionList",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        "pathname": 'service_execution_list'
      },
      {
        "index":1,
        "FunTitle":"銷售管理組合",
        "actionComponent":"",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        // "pathname": 'service_execution_list',
        subActions:[
          // {
          //   "index":1,
          //   "FunTitle":"銷售數據",
          //   "pathName": "sales_report",
          //   "actionComponent":"SalesReport",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // },
          {
            "index":1,
            "FunTitle":"預約數據",
            "pathName": "reservation_statistics",
            "actionComponent":"ReservationChart",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },
          // {
          //   "index":3,
          //   "FunTitle": "票券週期",
          //   "pathName": "ticket_life_report",
          //   "actionComponent": "TicketLifeReport",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // }
        ]
      },
      {
        "index":2,
        "FunTitle":"核銷日曆查看",
        "actionComponent":"ServiceExecutionView",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        "pathname": 'service_execution_view'
      },
      {
        "index":3,
        "FunTitle":"電子票券請款作業",
        "actionComponent":"PaymentFormAdminView",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        "pathname": 'payment_form_admin_view'
      },
      {
        "index":4,
        "FunTitle":"web核銷",
        "actionComponent":"StoreServiceExecution",
        "imgUrl":require('../assets/images/money_on@2x.png'),
        "pathname": 'store_service_execution'
      },
      // {
      //   "index":4,
      //   "FunTitle":"銷售管理報表",
      //   "actionComponent":"SalesViewCombo",
      //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
      //   "pathname": "sales_report"
      // },
    ],
    'merchant_store': [
      {
        "index":0,
        "FunTitle":"票券核銷請款查詢",
        "actionComponent":"ServiceExecutionList",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        "pathname": 'service_execution_list'
      },
      {
        "index":1,
        "FunTitle":"銷售管理組合",
        "actionComponent":"",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        // "pathname": 'service_execution_list',
        subActions:[
          // {
          //   "index":1,
          //   "FunTitle":"銷售數據",
          //   "pathName": "sales_report",
          //   "actionComponent":"SalesReport",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // },
          {
            "index":1,
            "FunTitle":"預約數據",
            "pathName": "reservation_statistics",
            "actionComponent":"ReservationChart",
            "imgUrl":require('../assets/images/appointment_on@2x.png'),
          },
          // {
          //   "index":3,
          //   "FunTitle": "票券週期",
          //   "pathName": "ticket_life_report",
          //   "actionComponent": "TicketLifeReport",
          //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
          // }
        ]
      },
      {
        "index":2,
        "FunTitle":"核銷日曆查看",
        "actionComponent":"ServiceExecutionView",
        "imgUrl":require('../assets/images/appointment_on@2x.png'),
        "pathname": 'service_execution_view'
      },
      {
        "index":3,
        "FunTitle":"web核銷",
        "actionComponent":"StoreServiceExecution",
        "imgUrl":require('../assets/images/money_on@2x.png'),
        "pathname": 'store_service_execution'
      },
      
      // {
      //   "index":3,
      //   "FunTitle":"銷售管理報表",
      //   "actionComponent":"SalesViewCombo",
      //   "imgUrl":require('../assets/images/appointment_on@2x.png'),
      //   "pathname": "sales_report"
      // },
      //{"index":3,"FunTitle":"劃位聊聊","actionComponent":"ChatReserve","imgUrl":require('../assets/images/money_on@2x.png')},
    ],
  },
  pageCodeMapper: {
    Login: {
      code: 1,
      name: '登入'
    },
    ServiceExecutionList: {
      code: 2,
      name: '核銷紀錄查詢'
    },
    // SalesReport: {
    //   code: 3,
    //   name: '銷售數據'
    // },
    ReservationChart: {
      code: 4,
      name: '預約數據'
    },
    ServiceExecutionView: {
      code: 5,
      name: '核銷日曆查看'
    },
    PaymentFormAdminView: {
      code: 6,
      name: '請款單查看'
    },
    StoreServiceExecution: {
      code: 7,
      name: '票券核銷'
    }
  }
}
